import { config } from '../config'

/** Minimal auth facade over Keycloak (OIDC, PKCE). In "disabled" mode it is a no-op. */
export interface Auth {
  enabled: boolean
  token(): Promise<string | undefined>
  logout(): void
  accountUrl?: string
}

let current: Auth = { enabled: false, token: async () => undefined, logout: () => {} }

export function auth(): Auth {
  return current
}

export async function initAuth(): Promise<Auth> {
  if (config.authMode === 'disabled') return current
  const { default: Keycloak } = await import('keycloak-js')
  const keycloak = new Keycloak({
    url: config.keycloakUrl,
    realm: config.keycloakRealm,
    clientId: config.keycloakClientId,
  })
  await keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  })
  current = {
    enabled: true,
    async token() {
      try {
        await keycloak.updateToken(30)
      } catch {
        await keycloak.login()
      }
      return keycloak.token
    },
    logout: () => void keycloak.logout({ redirectUri: window.location.origin }),
    accountUrl: keycloak.createAccountUrl(),
  }
  return current
}
